import { Sparkle } from "lucide-react";

export const Marquee = ({ items, className = "", iconClassName = "text-saffron", fast = false }) => {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={`${key}-${i}`} className="flex items-center">
          <span className="whitespace-nowrap px-6 sm:px-10">{item}</span>
          <Sparkle className={`w-4 h-4 shrink-0 ${iconClassName}`} fill="currentColor" />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`overflow-hidden ${className}`}>
      <div className={`flex w-max ${fast ? "animate-marquee-fast" : "animate-marquee"}`}>
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};

export const EditorialMarquee = ({ words, className = "" }) => {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {words.map((w, i) => (
        <span key={`${key}-${i}`} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display font-extrabold uppercase text-5xl sm:text-7xl text-stroke-aubergine">
            {w}
          </span>
          <span className="w-3 h-3 rounded-full bg-saffron shrink-0" />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`overflow-hidden py-10 select-none ${className}`} aria-hidden>
      <div className="flex w-max animate-marquee opacity-70">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};
